import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const UserLessonListLink = (_context: NavigationContext): Link => ({
        type: 'link',
        label: 'navigation.user_lesson_list',
        link: '/lessons/list/lessons',
        icon: 'navigation-link__list-item',
    }
);